import React from 'react';
import config from '../config';

const WhyCFO = () => {
  return (
    <section className="why-cfo-section" id="why-cfo">
      <div className="container">
        <div className="why-cfo-layout">

          {/* Right Image */}
          <div className="why-cfo-image">
            <div className="image-container">
              <img 
                src={`${config.imageBaseURL}${config.paths.images}why_cfo.webp`}
                alt="Why CFO Bridge - Professional Financial Services" 
                className="professional-image"
              />
            </div>
          </div>
          {/* Left Content */}
          <div className="why-cfo-content">
            <div className="section-content">
              <h2 className="main-heading">Why CFO Bridge?</h2>
              
              <div className="description" style={{ textAlign: 'justify' }}>
                <p>CFO Bridge UAE brings extensive global experience from 550+ successful engagements across India, Middle East, North Africa, and the United States, enabling businesses to transform finance into a true growth engine. Our presence in the UAE is built on an execution-focused approach that aligns strategic insight with the region’s dynamic business and regulatory environment.</p>
                <p>Our team of seasoned CFO consultants and partners works closely with leadership teams to drive clarity, control, and consistency in financial operations. By combining global perspective with local relevance, we help businesses make successful decisions, strengthen financial discipline, and scale with confidence across the MENA region.</p>
              </div>

              {/* CTA BUTTON */}
              <div className="why-cfo-cta">
                <a href="/about-us" className="why-cfo-btn">
                  Learn More About Us
                </a>
              </div>
            </div>
          </div>
          
        </div>
      </div>

      {/* Inline CSS for the new professional button */}
      <style>{`
        /* CTA wrapper */
        .why-cfo-cta {
          margin-top: 32px;
        }

        /* New Button Design */
        .why-cfo-btn {
          display: inline-block;
          font-family: 'Outfit', sans-serif;
          font-weight: 600;
          font-size: 14px;
          text-transform: uppercase;
          color: #ffffff;
          background: linear-gradient(135deg, #014293 0%, #1a5ebf 100%);
          padding: 14px 36px;
          border: none;
          border-radius: 50px;
          text-decoration: none;
          box-shadow: 0 8px 20px rgba(1, 66, 147, 0.3);
          transition: all 0.4s ease;
          position: relative;
          overflow: hidden;
        }

        /* Hover Effect */
        .why-cfo-btn:hover {
          transform: translateY(-3px) scale(1.05);
          box-shadow: 0 12px 24px rgba(1, 66, 147, 0.4);
          background: linear-gradient(135deg, #1a5ebf 0%, #014293 100%);
        }

        /* Subtle shine animation on hover */
        .why-cfo-btn::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: rgba(255, 255, 255, 0.15);
          transform: rotate(45deg) translateX(-100%);
          transition: transform 0.7s ease;
        }

        .why-cfo-btn:hover::before {
          transform: rotate(45deg) translateX(100%);
        }
      `}</style>

    </section>
  );
};

export default WhyCFO;